(function () {
  function init() {
    var params = new URLSearchParams(window.location.search);
    var order = params.get('order');
    var email = params.get('email');

    function prefill(id, value) {
      if (!value) return;
      var input = document.getElementById(id);
      if (!input) return;
      input.value = value;
      input.setAttribute('readonly', '');
    }

    prefill('withdrawal_order', order);
    prefill('withdrawal_email', email);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
